import React from 'react'
import { ArticleContentShare } from 'pages/Article/Content/components/ContentShare/index.js'
import ArticleChunkContent from 'pages/Article/Content/components/ChunkContent/index.js'
import hasReferencesStrUtil from 'pages/Article/Content/utils/has-references/index.js'
import { ArticleTableOfContents } from 'pages/Article/Content/components/TableOfContents/index.js'
import { ARTICLE_MARKDOWN_REGEX } from 'modules/articles/constants'

/**
 * @param value
 * @param hasShareButtons
 * @param hasRenderedShareAfterImageRef
 * @param title
 * @param url
 * @param img
 * @returns {JSX.Element}
 * @constructor
 */
export const ArticleContentChunks = React.memo(function ArticleContentChunks ({
  value,
  hasShareButtons,
  hasRenderedShareAfterImageRef,
  title,
  url,
  img
}) {
  const imageIndexRef = React.useRef(-1)
  const getChunks = () => {
    return value.split(/\n\n/g)
  }
  const getChunksCount = () => {
    return getChunks().length
  }
  const chunksCount = getChunksCount()

  const propsToPassToShare = {
    hasShareButtons,
    hasRenderedShareAfterImageRef,
    chunksCount,
    title,
    url,
    img
  }
  const hasReferences = hasReferencesStrUtil(value)
  const chunks = value.split(/\n\n/g)

  // Find the first chunk that contains an image
  const firstImageChunkIndex = chunks.findIndex((chunk) => {
    return ARTICLE_MARKDOWN_REGEX.IMG.test(chunk)
  })

  return (
    <>
      {
        chunks.map((chunk, i) => {
          const indexBeforeLast = hasReferences ? 2 : 1
          const isSecondLast = i === chunksCount - indexBeforeLast
          const isBeforeFirstImage = firstImageChunkIndex !== -1 && i === firstImageChunkIndex

          return (
            <React.Fragment key={i}>
              {
                isBeforeFirstImage && (
                  <ArticleTableOfContents
                    value={value}
                  />
                )
              }

              <ArticleChunkContent
                chunksCount={chunksCount}
                chunk={chunk}
                index={i}
                propsToPassToShare={propsToPassToShare}
                url={url}
                imageIndexRef={imageIndexRef}
              />

              {
                isSecondLast && (
                  <ArticleContentShare
                    pb='16px'
                    {...propsToPassToShare}
                  />
                )
              }
            </React.Fragment>
          )
        })

      }
    </>
  )
})
